export const config = {
	menu: {
		full: [
			{
				key: "home",
				icon: "home-line",
				label: "common.labels.home",
				url: `/home`,
			},
			{
				key: "members",
				icon: "group",
				label: "common.labels.members",
				url: "/members",
			},
			{
				key: "register",
				icon: "add-form",
				label: "common.labels.registrations",
				url: `/register`,
			},
			// {
			//     key: "finances",
			//     icon: "finances",
			//     label: "common.labels.finances",
			//     url: "/finances",
			// },
			// {
			//     key: "settings",
			//     icon: "settings",
			//     label: "common.labels.settings",
			//     url: "/config",
			// },
		],
		register: [
			{
				key: "users",
				icon: "group",
				label: "common.labels.users",
				url: `/register/user`,
			},
			{
				key: "plan",
				icon: "plans",
				label: "common.labels.plans",
				url: `/register/plan`,
			},
			{
				key: "module",
				icon: "no-image",
				label: "common.labels.modules",
				url: `/register/module`,
			},
			{
				key: "term",
				icon: "no-image",
				label: "common.labels.terms",
				url: `/register/term`,
			},
		],
	},
};
